import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=17ea08a4&scoped=true"
import script from "./newDetail.vue?vue&type=script&lang=js"
export * from "./newDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./newDetail.vue?vue&type=style&index=1&id=17ea08a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea08a4",
  null
  
)

export default component.exports